export const productCategories = [
  {
    id: 'capsules',
    name: 'Capsules',
    title: 'Ayurvedic Capsules',
    icon: 'ri-capsule-line',
    tagline: 'Precise herbal dosage in every capsule',
    description:
      'Convenient capsule formulations that deliver a consistent, measured dose of pure herbal extracts for targeted everyday care.',
    image: 'https://www.bestayush.com/images/products/img_6a71b68b83eff7.24283507.webp',
  },
  {
    id: 'tablet',
    name: 'Tablets',
    title: 'Ayurvedic Tablets',
    icon: 'ri-medicine-bottle-line',
    tagline: 'Classical tablets for daily wellness',
    description:
      'Traditional Ayurvedic tablets compressed from finely processed herbs, ideal for regular wellness routines and easy consumption.',
    image: 'https://www.bestayush.com/images/products/img_6a71d3cbe68d78.29139084.webp',
  },
  {
    id: 'syrup',
    name: 'Syrups',
    title: 'Ayurvedic Syrups',
    icon: 'ri-flask-line',
    tagline: 'Soothing herbal support, easy to take',
    description:
      'Pleasant-tasting herbal syrups prepared from carefully selected botanicals, perfect for gentle everyday support for all ages.',
    image: 'https://www.bestayush.com/images/products/img_6a711df1687898.67193112.webp',
  },
  {
    id: 'kashayam',
    name: 'Kashayam',
    title: 'Ayurvedic Kashayam',
    icon: 'ri-test-tube-line',
    tagline: 'Sugar free herbal formulations',
    description:
      'Classical sugar-free herbal syrups and decoctions brewed from slow-simmered herbs and roots, a time-honoured way to support everyday wellness.',
    image: 'https://www.bestayush.com/images/products/img_6a71bfbbecb4c2.02435709.webp',
  },
  {
    id: 'lehyam',
    name: 'Lehyam',
    title: 'Ayurvedic Lehyam',
    icon: 'ri-bowl-line',
    tagline: 'Nourishing herbal jams, made the classic way',
    description:
      'Rich, restorative lehyam prepared from age-old recipes with pure herbs, honey and ghee for deeply nourishing care.',
    image: 'https://www.bestayush.com/images/products/img_6a71c120633ec5.47016562.webp',
  },
  {
    id: 'oil',
    name: 'Oil',
    title: 'Ayurvedic Oils',
    icon: 'ri-oil-line',
    tagline: 'Therapeutic oils for massage and care',
    description:
      'Slow-cooked herbal oils for therapeutic massage and daily hair and skin care, prepared with pure botanical infusions.',
    image: 'https://www.bestayush.com/images/products/img_6a71b547185f69.51699238.webp',
  },
  {
    id: 'ointments',
    name: 'Ointments',
    title: 'Ayurvedic Ointments & Balms',
    icon: 'ri-hand-sanitizer-line',
    tagline: 'Balms & ointments for targeted relief',
    description:
      'Pain balms, roll-ons and soothing ointments formulated for fast, targeted relief and topical comfort where you need it most.',
    image: 'https://www.bestayush.com/images/products/img_6a72d1fc7fa714.22576636.webp',
  },
  {
    id: 'churanam',
    name: 'Churanam',
    title: 'Ayurvedic Churanam',
    icon: 'ri-flask-line',
    tagline: 'Classical herbal powders',
    description:
      'Finely milled classical churanam powders prepared from traditional recipes, ideal for daily digestive and everyday herbal care.',
    image: 'https://www.bestayush.com/images/products/img_6a71c5441d1dc5.24352316.webp',
  },
  {
    id: 'powder',
    name: 'Powder',
    title: 'Ayurvedic Powders',
    icon: 'ri-blaze-line',
    tagline: 'Face, oral & wellness powders',
    description:
      'A complete powder range — face care, oral care and wellness powders crafted from pure herbs for everyday use.',
    image: 'https://www.bestayush.com/images/products/img_6a71c5441d1dc5.24352316.webp',
  },
  {
    id: 'selfcare',
    name: 'Self Care',
    title: 'Ayurvedic Self Care',
    icon: 'ri-heart-line',
    tagline: 'Everyday personal care, the herbal way',
    description:
      'Herbal shampoos, soaps and personal care essentials that bring gentle, nature-backed care into your daily routine.',
    image: 'https://www.bestayush.com/images/products/img_6a71b4ad2be0b2.84734666.webp',
  },
];

export const products = [
  /* ── Capsules ── */
  {
    id: 'b-rumarthx-best-ds-capsule',
    name: 'B Rumarthx Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a7112e22d3261.53415322.webp',
    description:
      'A potent herbal blend traditionally used for comfort support in neuro-muscular pain, myalgia, joint pain, rheumatoid arthritis, spondylosis and lumbago.',
    benefits: ['Supports joint comfort', 'Eases muscular stiffness', 'Traditional anti-inflammatory herbs'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-rumarthx-plus-capsules',
    name: 'B Rumarthx Plus Best DS Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a7112fa3a6822.75188729.webp',
    description:
      'Advanced relief formula for neuro-muscular pain, joint pain, rheumatoid arthritis, spondylosis and lumbago with a stronger herbal blend.',
    benefits: ['Advanced pain support', 'Supports mobility', 'Blend of classical herbs'],
    rating: 4.5,
  },
  {
    id: 'b-rumarthx-capsules',
    name: 'B Rumarthx Best Capsules',
    category: 'capsules',
    pack: '60 Capsules',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71130ec654d5.99416480.webp',
    description:
      'Helps manage joint pain, muscular pain and rheumatoid arthritis with a natural herbal formulation designed for daily wellness routines.',
    benefits: ['Everyday joint support', 'Natural herbal formula', 'Easy to swallow capsules'],
    rating: 4.4,
  },
  {
    id: 'b-sp-soryn-capsules',
    name: 'B SP Soryn Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71b5df677d75.35755491.webp',
    description:
      'Specially formulated for psoriasis, fungal infections of the skin and photo-sensitive dermatitis, supporting clearer, calmer skin.',
    benefits: ['Supports skin health', 'Traditional blood purifying herbs', 'For recurring skin concerns'],
    rating: 4.5,
  },
  {
    id: 'b-hemi-guard-capsule',
    name: 'B Hemi Guard Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Anemia & Blood Health',
    image: 'https://www.bestayush.com/images/products/img_6a71b63f5dd672.37150370.webp',
    description:
      'Supports anemia recovery and helps improve hemoglobin levels naturally with iron-rich Ayurvedic herbs.',
    benefits: ['Supports haemoglobin', 'Iron-rich herbal blend', 'Daily wellness support'],
    rating: 4.5,
  },
  {
    id: 'mucowin-capsules',
    name: 'Mucowin Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Digestive Health',
    image: 'https://www.bestayush.com/images/products/img_6a71b64f20a077.49319011.webp',
    description:
      'Traditionally indicated on the product label for support relating to amoebic dysentery, with a time-tested herbal formulation.',
    benefits: ['Supports gut comfort', 'Time-tested formulation', 'Gentle on the stomach'],
    rating: 4.4,
  },
  {
    id: 'b-menoayur-capsule',
    name: 'B Menoayur Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: "Women's Health",
    image: 'https://www.bestayush.com/images/products/img_6a71b660ae0aa6.11555873.webp',
    description:
      "Supports women's health by addressing leucorrhea, trimester care, amenorrhea, fibroid uterus and PCOD holistically.",
    benefits: ["Women's wellness support", 'Hormonal balance herbs', 'Classical formulation'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-vitaalin-plus-capsule',
    name: 'B Vitaalin Plus Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: "Men's Vitality",
    image: 'https://www.bestayush.com/images/products/img_6a71b68b83eff7.24283507.webp',
    description:
      'Addresses inability to perform, premature ejaculation, erectile dysfunction, azoospermia and impotency with rejuvenating herbs.',
    benefits: ["Men's vitality support", 'Rejuvenating herbal blend', 'Traditional vajikarana herbs'],
    rating: 4.5,
  },
  {
    id: 'b-best-gold-capsules',
    name: 'B Best Gold Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: "Men's Vitality",
    image: 'https://www.bestayush.com/images/products/img_6a71b69df2c7f8.14808167.webp',
    description:
      'Supports male infertility, erectile dysfunction, premature ejaculation and azoospermia with a powerful herbal blend.',
    benefits: ["Men's fertility support", 'Powerful herbal blend', 'Daily vitality care'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'libidin-gold-capsules',
    name: 'Libidin Gold Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: "Men's Vitality",
    image: 'https://www.bestayush.com/images/products/img_6a71b6b52e7dc0.28202082.webp',
    description:
      'A gold-standard herbal formulation crafted to support male performance, stamina and overall reproductive wellness.',
    benefits: ['Supports stamina', 'Classical vajikarana herbs', "Men's wellness support"],
    rating: 4.5,
  },
  {
    id: 'b-matana-kameesh-capsule',
    name: 'B Matana Kameesh Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: "Men's Vitality",
    image: 'https://www.bestayush.com/images/products/img_6a71b6d27dafd3.72909043.webp',
    description:
      'Helps with inability to perform, impotency and erectile dysfunction with a traditional rejuvenating herbal blend.',
    benefits: ['Supports performance', 'Rejuvenating herbs', 'Classical formulation'],
    rating: 4.5,
  },
  {
    id: 'b-gas-capsule',
    name: 'B Gaso Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Gastric & Acidity',
    image: 'https://www.bestayush.com/images/products/img_6a71b6e30f9b75.74568576.webp',
    description:
      'Traditionally used for comfort support in gastric problems and hyperacidity with a soothing herbal blend.',
    benefits: ['Eases acidity', 'Supports healthy digestion', 'Cooling herbal action'],
    rating: 4.4,
  },
  {
    id: 'b-ulso-capsule',
    name: 'B Ulso Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Gastric & Acidity',
    image: 'https://www.bestayush.com/images/products/img_6a71b71d4d37a8.14572927.webp',
    description:
      'Traditionally used for comfort support in indigestion, hyperacidity, acid peptic ulcer and gastric problems.',
    benefits: ['Soothes hyperacidity', 'Supports gastric comfort', 'Cooling herbal action'],
    rating: 4.5,
  },
  {
    id: 'b-stonovate-capsules',
    name: 'B Stonovate Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Kidney & Urinary',
    image: 'https://www.bestayush.com/images/products/img_6a71b737af4de6.85263156.webp',
    description:
      'Supports the management of renal calculi and urinary dysfunction with a natural herbal formulation.',
    benefits: ['Kidney stone support', 'Urinary tract care', 'Classical herbal blend'],
    rating: 4.5,
  },
  {
    id: 'b-pain-o-forte-capsule',
    name: 'B Pain O Forte Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71bcfad0ead2.23728209.webp',
    description:
      'Traditionally indicated for support relating to neuro-muscular pain, myalgia, joint pain, rheumatoid arthritis, spondylosis and lumbago.',
    benefits: ['Joint & muscle support', 'Traditional pain herbs', 'Easy daily dosage'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-liveron-forte-capsule',
    name: 'B Liveron Forte Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Liver & Detox',
    image: 'https://www.bestayush.com/images/products/img_6a71b77b852802.86838420.webp',
    description:
      'Traditionally indicated for support relating to toxic hepatitis, chronic jaundice and chronic liver dysfunction.',
    benefits: ['Supports liver function', 'Hepatoprotective herbs', 'Detox support'],
    rating: 4.5,
  },
  {
    id: 'b-diah-care-capsule',
    name: 'B Diah Care Best DS Capsule',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Diabetes & Metabolism',
    image: 'https://www.bestayush.com/images/products/img_6a71b745133a16.16219665.webp',
    description:
      'Helps manage diabetes, diabetic neuropathy and diabetic retinopathy with a synergistic herbal formulation.',
    benefits: ['Supports sugar balance', 'Blend for nerve health', 'Classical anti-diabetic herbs'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'canvar-capsules',
    name: 'Canvar Capsules',
    category: 'capsules',
    pack: '30 Capsules',
    concern: 'Immunity Booster',
    image: 'https://www.bestayush.com/images/products/img_6a71b78feeac39.64743784.webp',
    description:
      'A powerful immunity builder crafted from premium herbal ingredients to support everyday resistance and vitality.',
    benefits: ['Builds immunity', 'Rich in antioxidants', 'Supports overall vitality'],
    rating: 4.5,
  },

  /* ── Syrups ── */
  {
    id: 'b-asmorth-syrup',
    name: 'B Asmorth Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Respiratory Health',
    image: 'https://www.bestayush.com/images/products/img_6a711df1687898.67193112.webp',
    description:
      'Formulated with Adhatoda zeylanica, Glycyrrhiza glabra, Solanum surattense and Ocimum sanctum for bronchial asthma, bronchitis and cough. Also acts as an appetizer, digestive and carminative.',
    benefits: ['Soothes the respiratory tract', 'Traditional cough relief', 'Acts as a gentle digestive'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-rumarthx-syrup',
    name: 'B Rumarthx Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71d7af2cb689.70454677.webp',
    description:
      'A liquid herbal support for neuro-muscular pains, myalgia, joint pain, rheumatoid arthritis, spondylosis and lumbago — easy to consume for all ages.',
    benefits: ['Joint comfort support', 'Easy liquid dosage', 'Traditional anti-inflammatory herbs'],
    rating: 4.5,
  },
  {
    id: 'b-menoayur-syrup',
    name: 'B Menoayur Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: "Women's Health",
    image: 'https://www.bestayush.com/images/products/img_6a71be8c1514b8.98512889.webp',
    description:
      "Supports women's health by addressing leucorrhoea, amenorrhea, fibroid uterus, irregular menstrual cycle and all menstrual problems.",
    benefits: ["Women's wellness support", 'Hormonal balance herbs', 'Classical formulation'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-sp-soryn-syrup',
    name: 'B SP Soryn Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71b5cd2397b1.25880819.webp',
    description:
      'A blood-purifying herbal syrup that supports skin health and helps manage psoriasis, fungal infections of the skin and photo-sensitive dermatitis.',
    benefits: ['Supports clear skin', 'Traditional blood purifier', 'Gentle liquid formula'],
    rating: 4.4,
  },
  {
    id: 'b-hemi-guard-syrup',
    name: 'B Hemi Guard Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Anemia & Blood Health',
    image: 'https://www.bestayush.com/images/products/img_6a71be9b770592.07608261.webp',
    description:
      'Helps to improve hemoglobin levels in anemia with a natural herbal formulation that supports everyday energy.',
    benefits: ['Supports haemoglobin', 'Iron-rich herbal blend', 'Daily wellness support'],
    rating: 4.5,
  },
  {
    id: 'b-liveron-forte-syrup',
    name: 'B Liveron Forte Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Liver & Detox',
    image: 'https://www.bestayush.com/images/products/img_6a71bea88062e3.46238952.webp',
    description:
      'Traditionally indicated for support relating to toxic hepatitis, chronic jaundice and chronic liver dysfunction with hepatoprotective herbs.',
    benefits: ['Supports liver health', 'Natural detox support', 'Hepatoprotective herbs'],
    rating: 4.5,
  },
  {
    id: 'b-ulso-syrup',
    name: 'B Ulso Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Gastric & Acidity',
    image: 'https://www.bestayush.com/images/products/img_6a71beb5e97a38.41632466.webp',
    description:
      'Traditionally used for comfort support in indigestion, hyperacidity and acid peptic ulcer with a soothing herbal blend.',
    benefits: ['Soothes hyperacidity', 'Supports gastric comfort', 'Cooling herbal action'],
    rating: 4.5,
  },
  {
    id: 'b-obee-forte-syrup',
    name: 'B Obee Forte Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Weight Management',
    image: 'https://www.bestayush.com/images/products/img_6a71bec40a7bf2.18126122.webp',
    description:
      'Helps manage hyper-cholesterolemia and fatty liver, supports reducing weight and corrects fat metabolism.',
    benefits: ['Supports weight management', 'Metabolic support', 'Herbal lipid care'],
    rating: 4.4,
  },
  {
    id: 'b-piloayur-syrup',
    name: 'B Piloayur Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Piles & Fissure',
    image: 'https://www.bestayush.com/images/products/img_6a71bed9685b29.92417054.webp',
    description:
      'Helps manage hemorrhoids, fissure in ano, chronic constipation, bleeding piles and fistula with natural herbs.',
    benefits: ['Supports piles care', 'Eases constipation', 'Soothing herbal blend'],
    rating: 4.4,
  },
  {
    id: 'b-stonavate-syrup',
    name: 'B Stonavate Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Kidney & Urinary',
    image: 'https://www.bestayush.com/images/products/img_6a71bf125bdfc7.13711076.webp',
    description:
      'Supports the management of renal calculi and urinary dysfunction with a natural herbal formulation.',
    benefits: ['Kidney stone support', 'Urinary tract care', 'Classical herbal blend'],
    rating: 4.5,
  },
  {
    id: 'b-esnovate-syrup',
    name: 'B Esnovate Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Respiratory Health',
    image: 'https://www.bestayush.com/images/products/img_6a71d99ff257e1.95009818.webp',
    description:
      'Traditionally used for comfort support in allergic sinusitis, rhinitis, sinus and headache with a targeted herbal blend.',
    benefits: ['Sinus comfort support', 'Targeted herbal blend', 'Supports clear breathing'],
    rating: 4.4,
  },
  {
    id: 'b-ulsogel-syrup',
    name: 'B Ulsogel Best DS Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Gastric & Acidity',
    image: 'https://www.bestayush.com/images/products/img_6a71bf37ce39f3.55599429.webp',
    description:
      'Provides quick and lasting relief from acidity, acidity heartburn and gas with a soothing herbal formulation.',
    benefits: ['Quick acidity relief', 'Soothes heartburn', 'Cooling gel action'],
    rating: 4.5,
  },
  {
    id: 'b-hirdaya-plys-syrup',
    name: 'B Hirdaya Plys Syrup',
    category: 'syrup',
    pack: '200 ml',
    concern: 'Heart & Cholesterol',
    image: 'https://www.bestayush.com/images/products/img_6a71bf48a52745.03079779.webp',
    description:
      'Helps control cholesterol, manage lipid profile and maintain healthy blood circulation with cardiac-supporting herbs.',
    benefits: ['Supports lipid balance', 'Cardiac-supporting herbs', 'Herbal heart care'],
    rating: 4.4,
  },

  /* ── Kashayam (Sugar Free) ── */
  {
    id: 'b-rumarthx-syrup-sf',
    name: 'B Rumarthx Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71bfbbecb4c2.02435709.webp',
    description:
      'A sugar-free herbal syrup for neuro-muscular pains, myalgia, joint pain, rheumatoid arthritis, spondylosis and lumbago.',
    benefits: ['Joint comfort support', 'Sugar free formula', 'Traditional anti-inflammatory herbs'],
    rating: 4.5,
  },
  {
    id: 'b-sp-soryn-syrup-sf',
    name: 'B SP Soryn Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71b58c29aa92.60490766.webp',
    description:
      'A sugar-free blood-purifying herbal syrup that supports skin health and helps manage psoriasis, fungal infections and photo-sensitive dermatitis.',
    benefits: ['Supports clear skin', 'Sugar free formula', 'Traditional blood purifier'],
    rating: 4.4,
  },
  {
    id: 'b-hemi-guard-syrup-sf',
    name: 'B Hemi Guard Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Anemia & Blood Health',
    image: 'https://www.bestayush.com/images/products/img_6a71bf67250341.25477725.webp',
    description:
      'A sugar-free iron-rich herbal syrup that supports anemia recovery and helps improve hemoglobin levels naturally.',
    benefits: ['Supports haemoglobin', 'Iron-rich herbal blend', 'Sugar free formula'],
    rating: 4.5,
  },
  {
    id: 'b-asmorth-syrup-sf',
    name: 'B Asmorth Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Respiratory Health',
    image: 'https://www.bestayush.com/images/products/img_6a71bfd5d87715.92623229.webp',
    description:
      'Formulated with Adhatoda zeylanica, Glycyrrhiza glabra, Solanum surattense and Ocimum sanctum for bronchial asthma, bronchitis and cough — now sugar free.',
    benefits: ['Soothes the respiratory tract', 'Traditional cough relief', 'Sugar free formula'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-liveron-forte-syrup-sf',
    name: 'B Liveron Forte Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Liver & Detox',
    image: 'https://www.bestayush.com/images/products/img_6a71bfe06bb251.48908732.webp',
    description:
      'A sugar-free hepatoprotective herbal syrup that supports liver function and natural detoxification.',
    benefits: ['Liver protection', 'Detox support', 'Sugar free formula'],
    rating: 4.5,
  },
  {
    id: 'b-menoayur-syrup-sf',
    name: 'B Menoayur Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: "Women's Health",
    image: 'https://www.bestayush.com/images/products/img_6a71bfedbd9290.51042855.webp',
    description:
      "A sugar-free herbal syrup that supports women's health, addressing leucorrhea, amenorrhea and fibroid uterus.",
    benefits: ["Supports women's wellness", 'Hormonal balance herbs', 'Sugar free formula'],
    rating: 4.5,
  },
  {
    id: 'b-ulso-syrup-sf',
    name: 'B Ulso Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Gastric & Acidity',
    image: 'https://www.bestayush.com/images/products/img_6a71c02a1374c6.63120132.webp',
    description:
      'A sugar-free soothing herbal syrup traditionally used for comfort support in indigestion, hyperacidity, acid peptic ulcer and gastric problems.',
    benefits: ['Soothes hyperacidity', 'Supports gastric comfort', 'Sugar free formula'],
    rating: 4.5,
  },
  {
    id: 'b-obee-forte-syrup-sf',
    name: 'B Obee Forte Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Weight Management',
    image: 'https://www.bestayush.com/images/products/img_6a71c036d45019.75742436.webp',
    description:
      'A sugar-free herbal syrup to help manage hyper-cholesterolemia, fatty liver, support weight reduction and correct fat metabolism.',
    benefits: ['Supports weight management', 'Metabolic support', 'Sugar free formula'],
    rating: 4.4,
  },
  {
    id: 'b-piloayur-syrup-sf',
    name: 'B Piloayur Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Piles & Fissure',
    image: 'https://www.bestayush.com/images/products/img_6a71c0422ffc84.24202545.webp',
    description:
      'A sugar-free herbal syrup to help manage hemorrhoids, fissure in ano, chronic constipation, bleeding piles and fistula.',
    benefits: ['Supports piles care', 'Eases constipation', 'Sugar free formula'],
    rating: 4.4,
  },
  {
    id: 'b-stonavate-syrup-sf',
    name: 'B Stonavate Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Kidney & Urinary',
    image: 'https://www.bestayush.com/images/products/img_6a71c04da3d561.95150828.webp',
    description:
      'A sugar-free herbal syrup supporting the management of renal calculi and urinary dysfunction.',
    benefits: ['Kidney stone support', 'Urinary tract care', 'Sugar free formula'],
    rating: 4.5,
  },
  {
    id: 'mahasnadi-syrup-sf',
    name: 'Maharasnadi Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71c0ae4f7935.13936009.webp',
    description:
      'A classical sugar-free formulation that helps manage generalized tremors, sciatica, rheumatism, brachial neuralgia and facial palsy.',
    benefits: ['Classical Maharasnadi blend', 'Supports nerve comfort', 'Sugar free formula'],
    rating: 4.5,
  },
  {
    id: 'b-esnovate-syrup-sf',
    name: 'B Esnovate Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Respiratory Health',
    image: 'https://www.bestayush.com/images/products/img_6a7202cd68ce03.43789777.webp',
    description:
      'A sugar-free herbal syrup traditionally used for comfort support in allergic sinusitis, rhinitis, sinus and headache.',
    benefits: ['Sinus comfort support', 'Targeted herbal blend', 'Sugar free formula'],
    rating: 4.4,
  },
  {
    id: 'b-diah-care-syrup-sf',
    name: 'B Diah Care Best DS Syrup (Sugar Free)',
    category: 'kashayam',
    pack: '200 ml',
    concern: 'Diabetes & Metabolism',
    image: 'https://www.bestayush.com/images/products/img_6a71c0fd2b06f3.78026723.webp',
    description:
      'A specialized sugar-free herbal syrup that helps manage diabetes, diabetic neuropathy and diabetic retinopathy.',
    benefits: ['Supports sugar balance', 'Blend for nerve health', 'Sugar free formula'],
    rating: 4.5,
  },

  /* ── Lehyam ── */
  {
    id: 'b-best-gold-lehyam',
    name: 'B Best Gold Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: "Men's Vitality",
    image: 'https://www.bestayush.com/images/products/img_6a71c120633ec5.47016562.webp',
    description:
      'An ayurvedic herbal jam formulated with potent rejuvenating herbs including Withania somnifera, Myristica fragrans and Vitis vinifera. It helps address male infertility issues, improves sexual health and enhances overall vitality.',
    benefits: ["Men's vitality support", 'Rejuvenating herbal blend', 'Prepared with ghee & honey'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'kusmanada-lehyam',
    name: 'Kusmanada Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Digestive Health',
    image: 'https://www.bestayush.com/images/products/img_6a71c12fda5ac5.22397903.webp',
    description:
      'A classical ayurvedic herbal jam prepared with Cuminum cyminum, Zingiber officinale and Piper longum. It supports digestion, acts as an appetizer and carminative and promotes overall wellness.',
    benefits: ['Supports healthy digestion', 'Appetizer & carminative', 'Classical preparation'],
    rating: 4.5,
  },
  {
    id: 'b-hemi-guard-lehyam',
    name: 'B Hemi Guard Best DS Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Anemia & Blood Health',
    image: 'https://www.bestayush.com/images/products/img_6a71c1611d9657.55411847.webp',
    description:
      'Formulated with Syzygium cumini, Vitis vinifera and Vetiveria zizanioides to help improve hemoglobin levels and support anemia recovery naturally.',
    benefits: ['Supports haemoglobin', 'Iron-rich herbal blend', 'Anemia recovery support'],
    rating: 4.5,
  },
  {
    id: 'b-menoayur-best-ds-lehyam',
    name: 'B Menoayur Best DS Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: "Women's Health",
    image: 'https://www.bestayush.com/images/products/img_6a71c187ca79c2.82304814.webp',
    description:
      "Contains Saraca asoca, Mangifera indica, Ficus racemosa and Asparagus racemosus to support women's health, addressing leucorrhea, amenorrhea and fibroid uterus.",
    benefits: ["Supports women's wellness", 'Restorative herbal blend', 'Prepared with ghee & honey'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'b-asmorth-lehyam',
    name: 'B Asmorth Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Respiratory Health',
    image: 'https://www.bestayush.com/images/products/img_6a71c1a1d6b907.00058825.webp',
    description:
      'Prepared with Pluchea lanceolata, Elettaria cardamomum, Cuminum cyminum and Piper longum, traditionally used for comfort support in bronchial asthma, bronchitis and cough while supporting digestion.',
    benefits: ['Respiratory comfort', 'Warming herbal blend', 'Traditional recipe'],
    rating: 4.4,
  },
  {
    id: 'b-sp-soryn-lehyam',
    name: 'B SP Soryn Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71b5558b1980.86880285.webp',
    description:
      'Formulated with Cyperus rotundus, Psoralea corylifolia and Rubia cordifolia for managing psoriasis, fungal infections of skin and photo-sensitive dermatitis.',
    benefits: ['Supports clear skin', 'Traditional blood purifier', 'Soothing herbal jam'],
    rating: 4.4,
  },
  {
    id: 'b-ulso-lehyam',
    name: 'B Ulso Best DS Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Gastric & Acidity',
    image: 'https://www.bestayush.com/images/products/img_6a71c1bfaf8b51.36839323.webp',
    description:
      'Contains Zingiber officinale, Piper nigrum, Aegle marmelos and Terminalia chebula, traditionally used for comfort support in indigestion, hyperacidity, acid peptic ulcer and gastric problems.',
    benefits: ['Soothes hyperacidity', 'Supports gastric comfort', 'Classical recipe'],
    rating: 4.5,
  },
  {
    id: 'b-pilo-ayur-lehyam',
    name: 'B Pilo Ayur Best DS Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Piles & Fissure',
    image: 'https://www.bestayush.com/images/products/img_6a71c1df553c22.84336072.webp',
    description:
      'Formulated with Operculina turpethum, Mimosa pudica and Abutilon indicum to help manage hemorrhoids, fissure in ano, chronic constipation, bleeding piles and fistula.',
    benefits: ['Supports piles care', 'Eases constipation', 'Gentle herbal blend'],
    rating: 4.4,
  },
  {
    id: 'b-liveron-forte-lehyam',
    name: 'B Liveron Forte Best DS Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Liver & Detox',
    image: 'https://www.bestayush.com/images/products/img_6a71c1f84e5055.83605964.webp',
    description:
      'Contains Glycyrrhiza glabra and Nymphaea stellata to provide effective support for toxic hepatitis, chronic jaundice and chronic liver dysfunctions.',
    benefits: ['Liver protection', 'Detox support', 'Hepatoprotective herbs'],
    rating: 4.5,
  },
  {
    id: 'b-stonavate-lehyam',
    name: 'B Stonavate Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Kidney & Urinary',
    image: 'https://www.bestayush.com/images/products/img_6a71c224496207.18882390.webp',
    description:
      'Formulated with Aegle marmelos and Tribulus terrestris to support the management of renal calculi and urinary dysfunctions.',
    benefits: ['Kidney stone support', 'Urinary tract care', 'Classical herbal blend'],
    rating: 4.5,
  },
  {
    id: 'b-rumarthx-best-ds-lehyam',
    name: 'B Rumarthx Best DS Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71c23dd84c94.35705456.webp',
    description:
      'Contains Zingiber officinale, Ricinus communis, Withania somnifera and Commiphora wightii, traditionally used for comfort support in neuro-muscular pains, myalgia, joint pain, rheumatoid arthritis, spondylosis and lumbago.',
    benefits: ['Joint & muscle support', 'Warming herbal blend', 'Traditional recipe'],
    rating: 4.5,
  },
  {
    id: 'b-laschol-plus-lehyam',
    name: 'B Laschol Plus Lehyam',
    category: 'lehyam',
    pack: '200 g',
    concern: 'Digestive Health',
    image: 'https://www.bestayush.com/images/products/img_6a71d389ef5ee7.59811330.webp',
    description:
      'Contains Terminalia bellerica, Terminalia chebula, Emblica officinalis, Cuminum cyminum and Operculina turpethum to provide laxative action, relieve constipation and offer carminative benefits.',
    benefits: ['Relieves constipation', 'Laxative & carminative', 'Classical triphala blend'],
    rating: 4.4,
  },

  /* ── Oil ── */
  {
    id: 'b-sp-soryn-oil',
    name: 'B SP Soryn Oil',
    category: 'oil',
    pack: '100 ml',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71b547185f69.51699238.webp',
    description:
      'A medicated ayurvedic oil formulated with Psoralea corylifolia, Ficus racemosa and Vetiveria zizanioides for managing psoriasis, fungal infections of skin and photo-sensitive dermatitis.',
    benefits: ['Supports clear skin', 'Soothes irritation', 'Medicated herbal oil'],
    bestSeller: true,
    rating: 4.5,
  },
  {
    id: 'b-vitaalin-plus-oil',
    name: 'B Vitaalin Plus Best DS Oil',
    category: 'oil',
    pack: '100 ml',
    concern: "Men's Vitality",
    image: 'https://www.bestayush.com/images/products/img_6a71c30b5e81a9.20968060.webp',
    description:
      'Contains Withania somnifera, Asparagus racemosus and Pueraria tuberosa to help address inability to perform, premature ejaculation, azoospermia and impotency.',
    benefits: ["Men's vitality support", 'Rejuvenating herbal blend', 'Massage-friendly oil'],
    rating: 4.5,
  },
  {
    id: 'b-rumarthx-best-ds-oil',
    name: 'B Rumarthx Best DS Oil',
    category: 'oil',
    pack: '100 ml',
    concern: 'Joint Pain & Arthritis',
    image: 'https://www.bestayush.com/images/products/img_6a71c316bbdc73.11610342.webp',
    description:
      'Formulated with Vitex negundo, Withania somnifera and Shorea robusta, traditionally used for comfort support in neuro-muscular pains, myalgia, joint pain and rheumatoid arthritis.',
    benefits: ['Warming massage oil', 'Eases muscular tension', 'Traditional herbal blend'],
    rating: 4.5,
  },

  /* ── Ointments ── */
  {
    id: 'rds-pain-balm-white',
    trademarked: true,
    name: 'RDS Pain Balm® (White)',
    category: 'ointments',
    pack: '30 g',
    concern: 'Pain Relief',
    image: 'https://www.bestayush.com/images/products/img_6a72d1fc7fa714.22576636.webp',
    description:
      'An effective Ayurvedic pain relief balm for joint and muscle pain, providing fast acting, long lasting comfort.',
    benefits: ['Fast acting relief', 'Long lasting comfort', 'For headache & body ache'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'rds-pain-balm-green',
    trademarked: true,
    name: 'RDS Pain Balm® (Green)',
    category: 'ointments',
    pack: '30 g',
    concern: 'Pain Relief',
    image: 'https://www.bestayush.com/images/products/img_6a7366cf3837d4.13529322.webp',
    description:
      'Enhanced green formula Ayurvedic pain relief balm with an advanced herbal blend for deeper, longer relief.',
    benefits: ['Advanced herbal blend', 'Deep penetrating relief', 'Pleasant herbal aroma'],
    rating: 4.5,
  },
  {
    id: 'rds-pain-balm-tube',
    trademarked: true,
    name: 'RDS Pain Balm® (Tube)',
    category: 'ointments',
    pack: '50 g',
    concern: 'Pain Relief',
    image: 'https://www.bestayush.com/images/products/img_6a711298502212.26056071.webp',
    description:
      'The trusted RDS pain relief formula in a convenient, travel-friendly tube for relief wherever you go.',
    benefits: ['Travel friendly tube', 'Easy application', 'Trusted RDS formula'],
    rating: 4.5,
  },
  {
    id: 'rds-roll-on',
    name: 'RDS Roll On',
    category: 'ointments',
    pack: '10 ml',
    concern: 'Pain Relief',
    image: 'https://www.bestayush.com/images/products/img_6a711276e139d9.30892563.webp',
    description:
      'A convenient roll-on applicator for precise, mess-free pain relief on the go.',
    benefits: ['Precise application', 'Mess-free roll-on', 'Pocket friendly'],
    bestSeller: true,
    rating: 4.6,
  },
  {
    id: 'rds-roll-on-gel',
    name: 'RDS Roll On Gel',
    category: 'ointments',
    pack: '10 ml',
    concern: 'Pain Relief',
    image: 'https://www.bestayush.com/images/products/img_6a71128a42db36.26129731.webp',
    description:
      'An advanced gel formula in a convenient roll-on applicator for cooling, fast-absorbing pain relief.',
    benefits: ['Cooling gel formula', 'Fast absorbing', 'Non-greasy roll-on'],
    rating: 4.5,
  },
  {
    id: 'rds-roll-on-green',
    name: 'RDS Roll On (Green)',
    category: 'ointments',
    pack: '10 ml',
    concern: 'Pain Relief',
    image: 'https://www.bestayush.com/images/products/img_6a7112a83ca498.33220081.webp',
    description:
      'Enhanced green formula in a precise roll-on applicator for mess-free relief from everyday aches.',
    benefits: ['Enhanced green formula', 'Precise roll-on', 'On-the-go relief'],
    rating: 4.4,
  },
  {
    id: 'b-ano-best-ointment',
    name: 'B Ano Best Ointment',
    category: 'ointments',
    pack: '30 g',
    concern: 'Piles & Fissure',
    image: 'https://www.bestayush.com/images/products/img_6a7112b4e26f22.30239853.webp',
    description:
      'A specialised formulation for the management of hemorrhoids and related discomfort, enriched with Shorea robusta, Curcuma longa, Terminalia chebula and Centella asiatica.',
    benefits: ['Soothes burning sensation', 'Supports healing', 'For internal & external piles'],
    rating: 4.5,
  },
  {
    id: 'b-sp-soryn-ointment',
    name: 'B SP Soryn Ointment',
    category: 'ointments',
    pack: '30 g',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a7112c130b960.73511396.webp',
    description:
      'An Ayurvedic topical formulation for fungal infections of the skin, leucoderma and other skin diseases, with Indigofera tinctoria and Psoralea corylifolia.',
    benefits: ['Combats fungal infection', 'Supports skin restoration', 'Reduces discoloration'],
    rating: 4.4,
  },

  /* ── Churanam ── */
  {
    id: 'aswaganthathi-churanam',
    name: 'Aswaganthathi Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Immunity Booster',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20aswagandha%20churanam%20fine%20brown%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20ashwagandha%20roots%20and%20green%20leaves%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-aswaganthathi-01&orientation=squarish',
    description:
      'Aswaganthathi Churanam is formulated with Ashwagandha and supportive herbs, traditionally taken to build strength and help the body cope with everyday stress.',
    benefits: ['Supports strength & stamina', 'Helps the body manage stress', 'Classical Ashwagandha recipe'],
    rating: 4.5,
  },
  {
    id: 'nilavembu-kudineer-churanam',
    name: 'Nilavembu Kudineer Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Immunity Booster',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20nilavembu%20kudineer%20churanam%20green%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20bitter%20herbs%20and%20nilavembu%20leaves%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-nilavembu-kudineer-01&orientation=squarish',
    description:
      'Nilavembu Kudineer Churanam is a classical herbal powder taken as a warm decoction to support immunity and help the body during seasonal fevers.',
    benefits: ['Supports natural immunity', 'Traditional fever-time decoction', 'Time-honoured Siddha blend'],
    rating: 4.5,
  },
  {
    id: 'athimathuram-churanam',
    name: 'Athimathuram Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Respiratory Health',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20athimathuram%20liquorice%20churanam%20fine%20beige%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20liquorice%20roots%20and%20green%20leaves%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-athimathuram-01&orientation=squarish',
    description:
      'Athimathuram Churanam is prepared from liquorice root and is traditionally used to soothe the throat, ease cough and support respiratory comfort.',
    benefits: ['Soothes the throat', 'Supports respiratory comfort', 'Ayurvedic liquorice root'],
    rating: 4.5,
  },
  {
    id: 'paranki-pattai-churanam',
    name: 'Paranki Pattai Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Skin & Psoriasis',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20paranki%20pattai%20churanam%20brown%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20bark%20pieces%20and%20dry%20roots%20arranged%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-paranki-pattai-01&orientation=squarish',
    description:
      'Paranki Pattai Churanam is a traditional herbal powder formulated with Paranki pattai and supportive herbs for everyday skin and wellness care.',
    benefits: ['Supports clear skin', 'Traditional blood purifying herb', 'Fine milled powder'],
    rating: 4.5,
  },
  {
    id: 'haridra-kanda-churanam',
    name: 'Haridra Kanda Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Skin & Psoriasis',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20haridra%20kanda%20churanam%20golden%20yellow%20turmeric%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20fresh%20turmeric%20rhizomes%20and%20green%20leaves%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-haridra-kanda-01&orientation=squarish',
    description:
      'Haridra Kanda Churanam is prepared from turmeric rhizome, traditionally valued for its cleansing, anti-inflammatory and skin-supporting properties.',
    benefits: ['Natural anti-inflammatory', 'Supports skin health', 'Purifying turmeric recipe'],
    rating: 4.5,
  },
  {
    id: 'pancha-churanam',
    name: 'Pancha Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Digestive Health',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20pancha%20churanam%20blended%20brown%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20dried%20spices%20and%20roots%20arranged%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-pancha-01&orientation=squarish',
    description:
      'Pancha Churanam is a blend of five classical herbs, taken to support healthy digestion, appetite and everyday gut comfort.',
    benefits: ['Supports healthy digestion', 'Helps stimulate appetite', 'Classical five-herb blend'],
    rating: 4.5,
  },
  {
    id: 'amalakyadi-churanam',
    name: 'Amalakyadi Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Digestive Health',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20amalakyadi%20churanam%20greenish%20brown%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20fresh%20amla%20indian%20gooseberry%20fruits%20and%20leaves%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-amalakyadi-01&orientation=squarish',
    description:
      'Amalakyadi Churanam is formulated with Amalaki (Indian gooseberry) and supportive herbs, traditionally taken for rejuvenation and digestive wellness.',
    benefits: ['Supports digestion', 'Rich in natural vitamin C', 'Classical rejuvenating recipe'],
    rating: 4.5,
  },
  {
    id: 'maruthampattai-churanam',
    name: 'Maruthampattai Churanam',
    category: 'churanam',
    pack: '100 g',
    concern: 'Heart & Cholesterol',
    image: 'https://readdy.ai/api/search-image?query=Ayurvedic%20maruthampattai%20churanam%20fine%20brown%20herbal%20powder%20heaped%20in%20a%20wooden%20bowl%20with%20arjuna%20bark%20pieces%20and%20dry%20herbs%20arranged%20around%20on%20a%20woven%20jute%20mat%2C%20soft%20green%20foliage%20background%2C%20warm%20natural%20lighting%2C%20professional%20product%20photography%20high%20detail&width=800&height=800&seq=churanam-maruthampattai-01&orientation=squarish',
    description:
      'Maruthampattai Churanam contains Maruthampattai and classical herbs, traditionally used to support heart wellness and everyday vitality.',
    benefits: ['Supports heart wellness', 'Traditional arjuna bark herb', 'Everyday vitality support'],
    rating: 4.5,
  },

  /* ── Powder ── */
  {
    id: 'hima-face-powder',
    name: 'Hima Face Powder',
    category: 'powder',
    pack: '50 g',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71c5441d1dc5.24352316.webp',
    description:
      'An Ayurvedic face powder formulated with Santalum album, Curcuma aromatica and Acorus calamus that soothes skin, heals minor burns and reduces pimples.',
    benefits: ['Absorbs excess oil', 'Unclogs pores', 'Promotes a clear complexion'],
    rating: 4.4,
  },
  {
    id: 'santuth-powder',
    name: 'Santuth Powder',
    category: 'powder',
    pack: '50 g',
    concern: 'Oral Care',
    image: 'https://www.bestayush.com/images/products/img_6a71c42852fd11.05024302.webp',
    description:
      'A traditional Ayurvedic tooth powder with Achyranthes aspera and the 3 myrobalans, specially formulated to reduce dental plaque and whiten external stains.',
    benefits: ['Reduces dental plaque', 'Whitens teeth', 'Strengthens gums'],
    rating: 4.5,
  },
  {
    id: 'hervigor-powder',
    name: 'Hervigor Powder',
    category: 'powder',
    pack: '200 g',
    concern: 'Weight Management',
    image: 'https://www.bestayush.com/images/products/img_6a71ca662c7df1.71580257.webp',
    description:
      'An effective dietary supplement formulated with wheat grass, maize, hand pound rice and sesame seeds to support weight management and lipid profile disorders.',
    benefits: ['Supports weight management', 'Rich in fibre & minerals', 'Daily metabolic support'],
    rating: 4.4,
  },

  /* ── Self Care ── */
  {
    id: 'b-best-shampoo',
    name: 'B Best Shampoo',
    category: 'selfcare',
    pack: '200 ml',
    concern: 'Hair Care',
    image: 'https://www.bestayush.com/images/products/img_6a71b4ad2be0b2.84734666.webp',
    description:
      'An Ayurvedic herbal shampoo enriched with Emblica officinalis, Glycyrrhiza glabra and Indigofera tinctoria that addresses hair loss, dandruff and greying.',
    benefits: ['Cleanses the scalp', 'Nourishes follicles', 'Gentle daily use'],
    bestSeller: true,
    rating: 4.5,
  },
  {
    id: 'b-keshwathi-best-ds-oil',
    name: 'B Keshwathi Best DS Oil',
    category: 'selfcare',
    pack: '100 ml',
    concern: 'Hair Care',
    image: 'https://www.bestayush.com/images/products/img_6a71b446d83c31.93423824.webp',
    description:
      'A premium Ayurvedic hair oil formulated with Brassica campestris, Lens culinaris and Myristica fragrans to control hair fall and encourage healthy growth.',
    benefits: ['Controls hair fall', 'Reduces dandruff', 'Supports healthy hair growth'],
    rating: 4.6,
  },
  {
    id: 'b-sp-soryn-soap',
    name: 'B SP Soryn Soap',
    category: 'selfcare',
    pack: '75 g',
    concern: 'Skin & Psoriasis',
    image: 'https://www.bestayush.com/images/products/img_6a71b532bc5b14.41281550.webp',
    description:
      'An Ayurvedic medicated soap infused with Aloe barbadensis, Curcuma longa and Curcuma aromatica that restores skin moisture and cleanses impurities.',
    benefits: ['Restores skin moisture', 'Cleanses impurities', 'Suitable for daily use'],
    rating: 4.4,
  },
];